import MuiListItemButton, {
  type ListItemButtonProps as MuiListItemButtonProps,
} from '@mui/material/ListItemButton';
import React from 'react';

import RouterLink from '../../RouterLink';

export type ListItemLinkProps = MuiListItemButtonProps;
const ListItemLink = React.forwardRef(
  (props: ListItemLinkProps, ref: React.ForwardedRef<HTMLDivElement>) => {
    return (
      <MuiListItemButton
        LinkComponent={RouterLink}
        {...props}
        ref={ref}
      ></MuiListItemButton>
    );
  },
);

ListItemLink.displayName = 'ListItemLink';

export default ListItemLink;
